export class ProductDownloads {

    constructor() {
        let downloadsSection = document.querySelector('.product-downloads');

        if(downloadsSection !== null) {
            let dropDown = downloadsSection.querySelector('#sort');
            this.form    = downloadsSection.querySelector('form');
            this.productsArea = downloadsSection.querySelectorAll('.title');

            dropDown.addEventListener('change', e => this.sortChanged());
            this.initialiseProductAccordion();
        }
    }

    sortChanged() {
        this.form.submit();
    }

    initialiseProductAccordion() {
        if(this.productsArea !== null) {
            this.productsArea.forEach(function(trigger) {

                let product = trigger.parentNode;
                trigger.addEventListener('click', e=>{
                    if (product.classList.contains('open')) {
                        product.classList.remove('open');
                    } else {
                        product.classList.add('open');
                    }
                });

            });
        }
    }
}


// WEBPACK FOOTER //
// ./assets/sass/components/product-downloads/product-downloads.js